<template>
  <div class="access-control">
    <a-spin :spinning="rebootLoading" tip="设备正在重启中..." size="large">
      <public-bread-crumb :routes="routes" />
      <public-top-bar
        placeholder="请输入机构名称、固件版本、SN码"
        :topBarBtns="topBarBtns"
        :onTableSearchFun="onTableSearchFun"
        @changeBasicSearchFun="changeBasicSearchFun"
        :ifShowHighFlag="true"
        :resetSearch="resetSearch"
        @unresetSearchFun="unresetSearchFun"
      >
        <template v-slot:highSearchGroup>
          <a-select
            placeholder="请选择接入的防疫平台"
            class="top-bar-input"
            v-model="searchObj.healthCodeType"
            allowClear
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option
              v-for="(i, index) in healthCodeTypeSelect"
              :key="index"
              :value="i.ind"
              >{{ i.value }}</a-select-option
            >
          </a-select>
          <a-select
            placeholder="请选择设备状态"
            class="top-bar-input"
            allowClear
            v-model="searchObj.status"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option
              v-for="(i, index) in stateSelects"
              :key="index"
              :value="i.ind"
              >{{ i.value }}</a-select-option
            >
          </a-select>
        </template>
      </public-top-bar>
      <public-table
        rowKey="sn"
        :columns="columns"
        :operateA="operateA"
        :operateWidth="operateWidth"
        :tableData="tableData"
        :tableInfo="tableInfo"
        :tableLoading="tableLoading"
        @selectTableRowFun="selectTableRowFun"
        @sortChangeFun="tableSorterFun"
      >
        <!-- 设备状态 -->
        <template slot="state" slot-scope="scope">
          <span :style="{ color: scope.row.state ? '#333' : '#red' }">{{
            scope.row.state ? "在线" : "离线"
          }}</span>
        </template>
        <!-- 故障监测 -->
        <template slot="instruc" slot-scope="scope">
          <span :style="{ color: scope.row.instruc ? 'red' : '#5862cb' }">{{
            scope.row.instruc ? "异常" : "正常"
          }}</span>
        </template>
      </public-table>
      <!-- 升级弹窗 this.updateServices.listServices-->
      <a-modal
        v-model="modalShow"
        title="选择升级包"
        width="660px"
        class="update-modal"
        centered
        :closable="false"
      >
        <public-update
          :addesstype="this.addesstype"
          v-if="modalShow"
          type="门禁设备"
          :updateServices="this.updateServices"
          :modalShow="modalShow"
          @closeUpdate="closeUpdate"
          @checkedVersion="checkedVersion"
        />
        <template slot="footer">
          <a-button
            key="back"
            type="primary"
            class="footer-btn"
            :loading="updateLoading"
            @click="updateMe"
            >确定</a-button
          >
          <a-button
            key="submit"
            @click="closeUpdate"
            class="footer-btn"
            style="margin-right: 0; background: #ecedff"
            >取消</a-button
          >
        </template>
      </a-modal>
      <!-- 故障状态弹窗 -->
      <public-status
        ref="statusWeight"
        :statusData="statusData"
        :statusType="statusType"
      />
      <!-- 延迟检测弹框 -->
      <a-modal
        v-model="delaydetectmod_modalShow"
        title="延迟监测"
        class="update-modal"
        width="460px"
        centered
        :closable="false"
      >
        <div class="ant-modal-body">
          <span style="line-height: 42px;">目标地址：</span>
          <a-input-search
            placeholder="请输入目标地址"
            enter-button="测试"
            @search="delaydetectmodSearchFun"
            v-model="delaydetectmod_testUrl"
          />
          <div class="delaydetectmod-test">
            <div v-if="delaydetectmod_test === 'test1'" style="color:#f00">
              此网络延迟的测试地址不可用
            </div>
            <div
              v-else-if="delaydetectmod_test === 'test2'"
              style="color:#31b520"
            >
              此地址可用
            </div>
            <div
              v-else-if="
                delaydetectmod_testUrl.length === 0 ||
                  delaydetectmod_test === 'test3'
              "
              style="color:#aaa"
            >
              请输入目标地址
            </div>
            <div v-else-if="delaydetectmod_test === 'test4'" style="color:#aaa">
              测试中<a-spin style="margin-left: 5px;" />
            </div>
            <div v-else-if="delaydetectmod_test === 'test5'" style="color:#fff">
              请输入目标地址
            </div>
          </div>
        </div>
        <template slot="footer">
          <a-button
            key="submit"
            @click="closeDelaydetectmod"
            class="footer-btn"
            style="margin-right: 0; background: #ecedff"
            >取消</a-button
          >
          <a-button
            key="back"
            type="primary"
            class="footer-btn"
            :loading="delayupdateLoading"
            @click="delayupdateMe"
            :disabled="delaydetectmod_disabled"
            >确定</a-button
          >
        </template>
      </a-modal>
      <!-- 测温模式切换 -->
      <a-modal
        v-model="changeTemperMode_modalShow"
        title="测温模式切换"
        class="update-modal"
        width="460px"
        centered
        :closable="false"
      >
        <div class="changeTemperMode-body">
          <span style="line-height: 32px;" class="changeTemperMode-title "
            >请从下方测温模式中选择：</span
          >
          <div class="changeTemperMode-main">
            <a-radio-group v-model="changeTemperMode_value">
              <a-radio :style="radioStyle" :value="0" class="radio-row">
                <span>
                  <a-row type="flex" justify="space-between">
                    <a-col :span="6">
                      极速测温
                    </a-col>
                    <a-col :span="18" class="upPackage-desc">
                      <a-tooltip
                        placement="topLeft"
                        title="测温数值经过分段处理，始终处于正常区间，用于项目运行"
                      >
                        测温数值经过分段处理，始终处于正常区间，用于项目运行
                      </a-tooltip>
                    </a-col>
                  </a-row>
                </span>
              </a-radio>
              <a-radio :style="radioStyle" :value="1" class="radio-row">
                <span>
                  <a-row type="flex" justify="space-between">
                    <a-col :span="6">
                      精准测温
                    </a-col>
                    <a-col :span="18" class="upPackage-desc">
                      <a-tooltip
                        placement="topLeft"
                        title="精准显示测温数值，用于项目交付"
                      >
                        精准显示测温数值，用于项目交付
                      </a-tooltip>
                    </a-col>
                  </a-row>
                </span>
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <template slot="footer">
          <a-button
            key="submit"
            @click="closechangeTemperMode"
            class="footer-btn"
            style="margin-right: 0; background: #ecedff"
            >取消</a-button
          >
          <a-button
            key="back"
            type="primary"
            class="footer-btn"
            :loading="delayupdateLoading"
            @click="closechangeTemperModeOK"
            >确定</a-button
          >
        </template>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
import { devicePublic, publicTableList } from '@/mixins/mixinsData'
import ACServices from '@/services/accessControl.services'
import DeviceServices from '@/services/deviceCommon.services'

export default {
  name: 'AccessControl',
  mixins: [devicePublic, publicTableList],
  watch: {
    delaydetectmod_testUrl: {
      immediate: true,
      handler: function (val) {
        this.delaydetectmod_test = ''
        this.delaydetectmod_disabled = true
        if (val.length == 0) {
          this.delaydetectmod_test = 'test3'
        }
      }
    },
    delaydetectmod_modalShow: {
      immediate: true,
      handler: function (val) {
        if (!val) {
          this.delaydetectmod_disabled = true
        }
      }
    }
  },
  data () {
    return {
      statusType: false,
      changeTemperMode_item: {},
      changeTemperMode_value: '',
      changeTemperMode_modalShow: false, // 测试弹框标杆
      radioStyle: {
        width: '100%',
        display: 'flex',
        height: '45px',
        lineHeight: '26px',
        alignItems: 'center'
      },
      delayupdateLoading: false,
      delaydetectmod_modalShow: false, // 延迟加载弹框标杆
      delaydetectmod_disabled: true, // 延迟加载弹框确认按钮禁用
      delaydetectmod_test: '', // 延迟加载弹框确认提示文字
      delaydetectmod_testUrl: '', // 延迟加载弹框地址
      addesstype: '', // 进行筛选
      // audioType: "AccessControl",
      // resetSearch: false,
      topBarBtns: [
        {
          name: '版本升级',
          type: 'primary',
          fun: this.openUpdate
        },
        {
          name: '重启',
          type: 'primary',
          fun: this.restartDevice
        },
        {
          name: '全选',
          type: '',
          fun: this.selectAllFun
        },
        {
          name: '重置',
          type: 'primary',
          fun: this.resetSearchFun
        },
        {
          name: '延迟监测修改',
          type: '',
          fun: this.delaydetectmodFun
        }
      ],
      healthCodeTypeSelect: [
        { ind: '0', value: '不接入健康码' },
        { ind: '1', value: '陕西一码通' },
        { ind: '2', value: '新疆防疫' },
        { ind: '3', value: '河北健康码' },
        { ind: '4', value: '宝鸡纳管' },
        { ind: '5', value: '西安纳管' }
      ],
      stateSelects: [
        { ind: 'true', value: '在线' },
        { ind: 'false', value: '离线' }
      ],
      routes: [
        {
          name: '门禁设备管理',
          path: '/access-control'
        }
      ],
      operateA: [
        {
          name: '一码通设置',
          fun: this.addPageOrEditPage
        },
        {
          name: '测温模式切换',
          fun: this.changeTemperMode
        }
        // {
        //   name: "删除",
        //   fun: this.rowDel,
        // },
      ],

      operateWidth: 250,
      intTimeout: 5000,
      intSent: 0, // 总共发送过几次请求
      bolIsTimeout: false, // 表示超时
      bolIsRunning: false // ping的状态
    }
  },
  mounted () {
    // 获取门禁设备列表
    this.getTableData(ACServices.GetAControlTable)

    // 故障状态Api
    this.statusServices = ACServices.GetStatus

    // 重启设备Api
    this.rebootServices = DeviceServices.RebootDevices

    // 升级Api
    this.updateServices = {
      listServices: DeviceServices.GetVersionTable,
      updateApi: DeviceServices.UpdateVersion
    }
  },
  methods: {
    // 测温模式切换弹框
    async changeTemperMode (item) {
      this.changeTemperMode_item = item
      if (item.tempMode) {
        this.changeTemperMode_value = Number(item.tempMode)
      } else {
        this.changeTemperMode_value = ''
      }
      this.changeTemperMode_modalShow = true
    },
    // 测温模式切换弹框-取消按钮
    closechangeTemperMode () {
      this.changeTemperMode_value = ''
      this.changeTemperMode_modalShow = false
      this.getTableData(ACServices.GetAControlTable)
    },
    // 测温模式切换弹框-确定按钮
    async closechangeTemperModeOK () {
      let params = {
        deviceId: this.changeTemperMode_item.sn,
        tempMode: this.changeTemperMode_value.toString()
      }
      // 设置当前设备的温度设置属性
      const { status, result } = await ACServices.UpdateTempMode(params)
      if (status === 0) {
        this.changeTemperMode_modalShow = false
        this.getTableData(ACServices.GetAControlTable)
      }
    },

    // 版本升级弹窗
    openUpdate () {
      if (this.tableInfo.selectRows.length <= 0) {
        this.$message.warning('请选择需要升级的设备')
        return
      }

      let checkType = this.checkAddRessType(this.tableInfo.selectRowDate)
      checkType
        ? this.$message.warning('请选中相同型号的设备')
        : (this.modalShow = true)
    },

    // 校验选择机构类型
    checkAddRessType (arr) {
      this.addesstype = arr[0].deviceType
      let checkAddressType = arr.some((item, index) => {
        return item.deviceType !== this.addesstype
      })
      return checkAddressType
    },

    // 延迟加载弹窗
    async delaydetectmodFun () {
      if (this.tableInfo.selectRows.length <= 0) {
        this.$message.warning('请选择需要修改的设备')
        return
      }
      let checkType = this.checkAddRessType(this.tableInfo.selectRowDate)
      if (checkType) {
        this.$message.warning('请选中相同型号的设备')
        return
      }
      let params = {
        address: '',
        list: this.tableInfo.selectRows
      }
      const { status, result } = await ACServices.GetDelayDetection(params)
      if (status === 0) {
        this.delaydetectmod_testUrl = result
        this.delaydetectmod_modalShow = true
      }
      this.delaydetectmod_test = 'test5'
    },
    // 延迟加载弹窗--取消
    closeDelaydetectmod () {
      this.delaydetectmod_modalShow = false
    },
    // 延迟加载弹窗--确定
    async delayupdateMe () {
      this.delayupdateLoading = true
      let params = {
        address: this.delaydetectmod_testUrl,
        list: this.tableInfo.selectRows
      }
      const { status, result } = await ACServices.SettingDelayDetection(params)
      this.delayupdateLoading = false

      if (status === 0) {
        this.delaydetectmod_modalShow = false
      }
    },
    // 延迟加载弹窗测试按钮
    async delaydetectmodSearchFun (value) {
      if (!value) {
        return
      }
      this.delaydetectmod_test = 'test4'
      // this.ping(value, this);
      let params = {
        address: value
      }
      const { status, result } = await ACServices.DelayDetection(params)
      if (status !== 0) {
        this.delaydetectmod_test = 'test1'
        return
      }
      if (result) {
        this.delaydetectmod_test = 'test2'
        this.delaydetectmod_disabled = false
      } else {
        this.delaydetectmod_test = 'test1'
        this.delaydetectmod_disabled = true
      }
    },

    // clearall(e) {
    //   e.stopPropagation()
    //   this.searchObj.healthCodeType = "";
    // },

    // 编辑?新增?
    addPageOrEditPage (item) {
      if (item && item.sn) {
        this.$router.push(`/access/onecode?id=${item.sn}`)
      }
      //   else {
      //     this.$router.push("/system/modify-form");
      //   }
    }
    // 升级
    // okUpdateVersion () {
    //   this.updateMe('/access-control')
    // }
  }
}
</script>

<style lang="less">
.top-bar-input {
  width: 396px;
  margin-right: 24px;
}
.update-modal {
  height: 439px;
  .ant-modal-content {
    .ant-modal-header {
      height: 53px;
      padding: 16px 0;
      text-align: center;
    }
    .ant-modal-body {
      // height: 320px;
      padding: 16px 16px 0;
      .delaydetectmod-test {
        padding: 12px 0;
      }
    }
    .ant-modal-footer {
      height: 64px;
      padding: 16px;
      text-align: center;
    }
  }

  .changeTemperMode-body {
    padding: 0 16px 16px;
    box-sizing: border-box;
    .changeTemperMode-title {
      color: #000;
      font-weight: 500;
    }
    .changeTemperMode-main {
      .radio-row {
        span.ant-radio + * {
          width: 95%;
        }

        .upPackage-desc {
          color: #aaa;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .footer-btn {
    width: 88px;
    height: 32px;
    margin-right: 32px;
    border-radius: 3px;
    border: 0px;
  }
}
</style>
